import { render, staticRenderFns } from "./ApproveIdeaList.vue?vue&type=template&id=91b528f8&"
import script from "./ApproveIdeaList.vue?vue&type=script&lang=js&"
export * from "./ApproveIdeaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports